import { useMutation } from '@tanstack/react-query'
import { request } from 'Lib/axios'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { CouponType } from '../components/Coupon/Coupon'

export type CouponResponse = {
  data: CouponType
}

const validateCoupon = async (coupon: string) => {
  const accountId = useUserStore.getState().accountId

  return await request<CouponResponse>({
    url: `accounts/${accountId}/subscriptions/coupon/validate?couponId=${coupon}`,
    method: 'GET',
  })
}

export const useValidateCoupon = () => {
  const { mutate, isLoading, isError, error, data } = useMutation(validateCoupon, {})
  return { mutate, isLoading, isError, error, data }
}
